module.exports = __webpack_public_path__ + "static/media/hospital_closures_illo_s_s_s_s_dox_test.bb13e70f.jpg";